const config = {
    env: process.env.REACT_APP_ENV,
    api_url: process.env.REACT_APP_API_URL,
    shop_url: process.env.REACT_APP_SHOP_ASSET_URL,
    browse_netsuite_entity: '99999999',
    product_formats: ['playaway', 'launchpad', 'wonderbook', 'recorded-books'],
    product_lines: [
        'playaway',
        'playaway_kids',
        'launchpad',
        'launchpad_academy',
        'wonderbook_read_along',
        'wonderbook_sing_along'
    ],
    allowed_pif_formats: ['playaway'],
    allowed_sop_formats: {
        playaway: ['playaway', 'recorded-books'],
        'recorded-books': ['recorded-books', 'playaway'],
        view: ['view'],
        bookpack: ['bookpack'],
        launchpad: ['launchpad']
    },
    binding_types: [
        {
            name: 'Prebound',
            key: 'prebound',
            default: true
        },
        {
            name: 'Trade Hardcover',
            key: 'hardcover'
        }
    ],
    channel: 'SHOP',
    pkg_types: [
        {
            name: 'Portfolio Case',
            key: 'portfolio_case'
        },
        {
            name: 'Hanging Bag',
            key: 'hanging_bag'
        }
    ],
    sites: [
        { key: 'SHOP', label: 'shop.playaway.com' },
        { key: 'BOP', label: 'bop.playaway.com' }
    ]
};
export default config;
